"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _BillingDetailsWidget = _interopRequireDefault(require("../../02_molecules/BillingDetailsWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BillingDetailsPage = function BillingDetailsPage(_ref) {
  var sdk = _ref.sdk,
      _ref$userPassengerId = _ref.userPassengerId,
      userPassengerId = _ref$userPassengerId === void 0 ? null : _ref$userPassengerId,
      _ref$savedPassengers = _ref.savedPassengers,
      savedPassengers = _ref$savedPassengers === void 0 ? [] : _ref$savedPassengers,
      _ref$billingPassenger = _ref.billingPassengerId,
      billingPassengerId = _ref$billingPassenger === void 0 ? null : _ref$billingPassenger,
      _ref$setBillingInfo = _ref.setBillingInfo,
      setBillingInfo = _ref$setBillingInfo === void 0 ? function () {} : _ref$setBillingInfo,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack;
  var translatorForNamespace = sdk.i18n.translatorForNamespace;
  var t = translatorForNamespace('BillingDetailsPage');
  var title = t('Billing details');
  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: title,
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_BillingDetailsWidget["default"], {
    sdk: sdk,
    userPassengerId: userPassengerId,
    savedPassengers: savedPassengers,
    billingPassengerId: billingPassengerId,
    setBillingInfo: setBillingInfo,
    translatorForNamespace: sdk.i18n.translatorForNamespace,
    onBack: onBack
  }));
};

var _default = BillingDetailsPage;
exports["default"] = _default;